import * as React  from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';

class MultiChoiceList extends Base{
    constructor(props){
        super(props);
    }

    renderOnCard() {
        let {renderType, data, showLabel=false} = this.props;
        if(Array.isArray(data))
            data = data[0];
        return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label || data.FieldGroup} </label>: {data.Value?data.Value.split(",").join(", "):'-'}</li>)
            :
                (<li data-test={data.Value}>{data.Value?data.Value:'-'}</li>)
    }
    renderOnGrid() {
        return (
            <div></div>
        )
    }
    renderOnDetail() {
        let {renderType, data, showLabel=false} = this.props;
        if(Array.isArray(data))
            data = data[0];
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{data.Value?data.Value.split(",").join(", "):'-'}</li>)
                :
                    (<li data-test={data.Value}>{data.Value?data.Value:'-'}</li>)
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label} </label>{data.Value?data.Value.split(",").join(", "):'-'}</li>)
                :
                    (data.Value?data.Value:'-')
        } else{
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label}: </label>{data.Value?data.Value.split(",").join(", "):'-'}</React.Fragment>)
                :
                    (data.Value?data.Value:'-')
        }
    }

    renderOnCreate() {
        return (
            <div>need to insert template</div>
        )
    }
}

export default MultiChoiceList;